<template>
    <div class="main d-flex flex-column justify-content-center bg-white">
        <div class="bg-g-transparent-light">
            <section id="brn-special-offers" v-if="content['special-offers-hero'].data.title || content['special-offers-hero'].data.text">
                <BorderDecoration primary="var(--color-secondary)" secondary="var(--color-gray-light)" style="left: -5%" />
                <div class="container">
                    <div class="title">
                        <ChalkDecoration class="m-auto mb-4">
                            <h3 v-html="content['special-offers-hero'].data.title"></h3>
                        </ChalkDecoration>
                        <p v-html="content['special-offers-hero'].data.text"></p>
                    </div>
<!--                    <div class="row offers-grid">-->
<!--                        <div v-for="(specialOffer, index) in specialOffers" :key="index" class="col-md-12 col-lg-6 col-xl-4 p-0">-->
<!--                            <SpecialOfferCard-->
<!--                                :special-offer="specialOffer"/>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </section>
            <section class="mt-5">
                <div v-if="specialTours.length" class="container d-flex flex-column flex-lg-row gap-4 mb-5">
                    <h4 class="text-center">Type:</h4>
                    <div class="tour-tags-container flex-wrap justify-content-center justify-content-lg-start">
                        <button class="btn tour-tag-item" :class="tags.length === 0 ?'btn-primary' : 'btn-dark'" @click="tags = []">
                            All
                        </button>
                        <button v-for="tag in tagsAvailable" :key="tag" class="btn tour-tag-item" :class="tags.indexOf(tag) !== -1 ?'btn-primary' : 'btn-dark'" @click="tagToggle(tag)">
                            {{ tag }}
                        </button>
                    </div>
                </div>
            </section>
            <section id="brn-tours-list">
                <div class="container">
                    <div class="row m-0">
                        <div v-for="tour in filteredTours" :key="tour.id" class="col-lg-6">
                            <TourExtendedCard
                                :tour="tour"
                                :page-slug="getPageSlugByLayout('tour-single')"
                                class="mb-4"/>
                        </div>
                    </div>
                </div>
            </section>
            <section id="brn-partners">
                <div class="container">
                    <div class="title">
                        <ChalkDecoration class="m-auto mb-4">
                            <h3 v-html="content['special-offers-partners'].data.title"></h3>
                        </ChalkDecoration>
                        <p v-html="content['special-offers-partners'].data.text"></p>
                    </div>
                </div>
                <OwlCarousel
                    class="owl-container"
                    :responsive="{
                        0: {
                            items: 3
                        },
                        768: {
                            items: 5
                        },
                        1200: {
                            items: 6
                        }
                    }"
                    :loop="true"
                    :nav="false"
                    :dots="false">
                    <div v-for="(item, index) in content['special-offers-partners'].data.items" class="partner-logo">
                        <img :src="'/storage/components/special-offers-partners/' + item.logo" :alt="item.title">
                    </div>
                </OwlCarousel>
            </section>
            <section id="brn-bike-promo">
                <div class="container">
                    <div class="row align-items-center mt-3">
                        <div class="col-lg-5 promo-info">
                            <ChalkDecoration class="mb-4">
                                <h3 v-html="content['special-offers-promo'].data.title"></h3>
                            </ChalkDecoration>
                            <p v-html="content['special-offers-promo'].data.text"></p>
                            <img :src="'storage/components/special-offers-promo/' + content['special-offers-promo'].data.logo" alt="Logo">
                        </div>
                        <div class="col-lg-7 promo-image">
                            <img :src="'storage/components/special-offers-promo/' + content['special-offers-promo'].data.image" :alt="content['special-offers-promo'].data.title">
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <section id="brn-special-needs" class="diagonal bg-diagonal-light bg-diagonal-waves">
            <BorderDecoration primary="var(--color-secondary)" secondary="var(--color-gray-light)" class="top-right" />
            <div class="container-fluid">
                <div class="row align-items-end flex-lg-nowrap">
                    <div class="block-info">
                        <ChalkDecoration :decorated="true">
                            <h2 v-html="content['special-offers-special-needs'].data.title"></h2>
                        </ChalkDecoration>
                        <div class="description" v-html="content['special-offers-special-needs'].data.text"></div>
                    </div>
                    <div class="block-slider">
                        <OwlCarousel v-if="specialNeedsItems.length"
                            :responsive="{
                                0: {
                                    items: 1
                                },
                                768: {
                                    items: 2
                                },
                                1200: {
                                    items: 2.25
                                }
                            }"
                            :loop="true"
                            :dots="false"
                            :nav="false" >
                            <div v-for="(item, index) in specialNeedsItems" :key="index" class="card m-0">
                                <div class="card-body">
                                    <h4>{{ item.type_name }}</h4>
                                    <div class="product-image" :class="{ unavailable: item.image.image === null }"
                                         :style="'background-image: url(' + (item.image.image ? item.image.fullImage : './assets/images/icons/no-image.png') + ')'">
                                    </div>
                                </div>
                            </div>
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
import ChalkDecoration from "../components/elements/ChalkDecoration";
import OwlCarousel from "vue-owl-carousel";
import BorderDecoration from "../components/elements/BorderDecoration";
import TourExtendedCard from "../components/cards/TourExtendedCard";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import ApiRequest from "../../utils/api-request";
import SpecialOfferCard from "../components/cards/SpecialOfferCard";
import {mapActions, mapGetters} from "vuex";
export default {
    name: "SpecialOffers",
    components: {SpecialOfferCard, BorderDecoration, OwlCarousel, ChalkDecoration, TourExtendedCard},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            specialOffers: [],
            specialNeedsItems: [],
            tags: []
        }
    },
    computed: {
        ...mapGetters('app', ['specialTours']),
        tagsAvailable() {
            return [...new Set(Array.prototype.concat.apply([], this.specialTours.filter(tour => (tour.tags !== null && tour.tags.length)).map(tour => JSON.parse(tour.tags))))];
        },
        filteredTours() {
            if (this.tags.length) {
                return this.specialTours.filter(tour => {
                    // parsing tags
                    let tags = JSON.parse(tour.tags);
                    // show tours without tags or if tour's tag is in enabled list
                    return tags.filter(tag => this.tags.includes(tag)).length > 0;
                });
            }
            //return all tours
            return this.specialTours;
        }
    },
    methods: {
        ...mapActions('app', ['fetchTours']),
        tagToggle(tag) {
            return this.tags.includes(tag) ? this.tags.splice(this.tags.indexOf(tag), 1) : this.tags.push(tag);
        }
    },
    beforeMount() {
        new ApiRequest().getBikes(false).then((response) => {
            this.specialNeedsItems = response.data.bikes.filter(bike => bike.special_needs === 1);
        });
    },
    mounted() {
        new ApiRequest().getSpecialOffers().then(
            (response) => {
                this.specialOffers = response.data.data;
            }
        );
        this.fetchTours();
    }
}
</script>

<style lang="scss" scoped>
.bg-transparent-to-white {
    background: linear-gradient(180deg, #f8f8ff, rgb(255, 255, 255));
}

</style>
